/* eslint-disable react/prop-types */
import React from "react";
import type {TableData} from "./ConstructionTableProps";
import ConstructionTableRow from "./ConstructionTableRow";
import ConstructionTableRowWithPossibleEmptyRows from "./ConstructionTableRowWithPossibleEmptyRows";

interface ConstructionTableRowChooserProps {
  constructionId: string;
  constructionElementsName: string;
  constructionPartItems: TableData[];
  isAccepted: boolean;
}

const ConstructionTableRowChooser: React.FunctionComponent<ConstructionTableRowChooserProps> = ({
  constructionId,
  constructionElementsName,
  constructionPartItems,
  isAccepted,
}) => {
  if (constructionElementsName === "footplates" || constructionElementsName === "foundations") {
    return (
      <ConstructionTableRowWithPossibleEmptyRows
        constructionId={constructionId}
        constructionElementsName={constructionElementsName}
        constructionPartItems={constructionPartItems}
        isAccepted={isAccepted}
      />
    );
  }
  return (
    <tbody>
      {constructionPartItems.map((constructionPartItem, i) => (
        <ConstructionTableRow
          constructionId={constructionId}
          constructionElementsName={constructionElementsName}
          constructionPartItem={constructionPartItem}
          key={i}
          isAccepted={isAccepted}
        />
      ))}
    </tbody>
  );
};

export default ConstructionTableRowChooser;
